window.reqListener = function () {
  const res = JSON.parse(this.responseText);

  // Articles section
  const articles = document.getElementById('articles');

  for (let i = 0; i < res.posts.length; i++) {
    const post = res.posts[i];

    // Container (anchor)
    const a = document.createElement('a');
    a.setAttribute('href', post.url);
    a.setAttribute('aria-labelledby', post.id);

    // Article
    const article = document.createElement('article');

    // Date element
    const pDate = document.createElement('p');
    pDate.className = 'w5';
    pDate.innerText = post.date;
    article.appendChild(pDate);

    // Title
    const h3 = document.createElement('h3');
    h3.setAttribute('id', post.id);
    h3.innerText = post.title;
    article.appendChild(h3);

    // Image
    const img = document.createElement('img');
    img.setAttribute('src', post.image);
    img.setAttribute('alt', '記事の写真');
    article.appendChild(img);

    // Description
    const pDesc = document.createElement('p');
    pDesc.innerText = post.description;
    article.appendChild(pDesc);

    // Read more
    const pMore = document.createElement('p');
    pMore.className = 'cl-green w5';
    pMore.innerHTML = '詳しくはこちら　&rarr;';
    article.appendChild(pMore);

    a.appendChild(article);

    articles.appendChild(a);
  }
};

if (document.location.pathname === '/blog/') {
  const environment = document.location.host.indexOf('.dev') === -1 ? 'production' : 'staging';

  const oReq = new XMLHttpRequest();
  oReq.addEventListener('load', window.reqListener, { once: true });
  oReq.open('GET', 'https://blog.openrm.jp/posts-' + environment + '.json');
  oReq.send();
}
